define('components/course/models/slide-type/pre-test',[
    "components/course/models/slide-type/tei-wrapper"
], function(BaseModel) {
    "use strict";

    return BaseModel.extend({
        "populateDefaultData": function() {
            if (!this.get('data')) {
                this.set('data', {
                    "teaGUID": null,
                    "title": null,
                    "studentResponseScore": 0,
                    "bAddCustomFeedback": false,
                    "sCustomFeedback": "",
                    "userScoreStatus": null,
                    "maxScoreStatus": null,
                    "lastLoadedIndex": null
                });
            }
            BaseModel.prototype.populateDefaultData.call(this);
            return this;
        },

        "authoringJSONKey": function() {
            return _.extend(BaseModel.prototype.authoringJSONKey.call(this), {
                "data": {
                    "teaGUID": null,
                    "title": null,
                    "studentResponseScore": null,
                    "bAddCustomFeedback": null,
                    "sCustomFeedback": null,
                    "userScoreStatus": null,
                    "maxScoreStatus": null,
                    "globalComponentData": null
                }
            });
        }
    });
});

